import AppLayout from "@/layouts/AppLayout.tsx";
import RestrictedPortalLayout from "@/layouts/RestrictedPortalLayout.tsx";
import { useEmployeeMe } from "@/queries/employees/use-employees.query.ts";
import { PortalAccessMode } from "@/types/employees/employee.types.ts";

export default function AuthenticatedPortalLayout() {
  const { data: employeeMe } = useEmployeeMe();

  if (employeeMe && employeeMe.portal_access_mode !== PortalAccessMode.full) {
    return <RestrictedPortalLayout />;
  }

  return <AppLayout />;
}
